"use strict";
var lib_core = require("lib-core");
var cio_config = require("cio-config");

var TrayAssetSearchTabContentModel = function (rootStateMachine, dataLoader) {
    var self = this;
    lib_core.Model.call(this);

    this.rootStateMachine = rootStateMachine;
    this.dataLoader = dataLoader;

    this.loading = false;
    this.all_loaded = false;
    this.request_id = 0;
    this.loadingQuery = false; 
    this.loadDelay = null;

    this.visible = this.value("visible", true);

    // TODO: most of the following fields shouldn't be modelfields, since they are not user customizable => it is just configuration and can be stored directly in this object
    this.name                 = this.value("name", true);
    this.title                = this.value("title", true);
    this.template             = this.value("template", true);
    this.alternative_template = this.value("alternative_template", true);
    this.url                  = this.value("url", true);    // TODO: url should only be composed in contentserver client, otherwise this can't be easily reused in a offline app
    this.library              = this.value("library", true);
    this.query                = this.value("query", true);
    this.query("");
    this.default_query_fields = this.value("default_query_fields", true);
    this.data                 = this.value("data", true);
    this.numberOfResults      = this.value("numberOfResults", true);
    this.sorting              = this.value("sorting", true);
    this.sortIsProp           = this.value("sortingIsProp", true);
    this.sorting("updated_at");

    this.sorting_direction    = this.value("sorting_direction", true);
    this.sorting_direction("desc");
    this.noSearch = this.value("noSearch", true); 

    this.pathSuffix           = this.value("pathSuffix", true);
    this.pathSuffix("");

    this.url.onChange("url_change", function () {self.reload();});
    this.query.onChange("query_change", function () {self.reload();});
    this.sorting.onChange("sorting_change", function () {self.reload();});
    this.sorting_direction.onChange("sorting_direction_change", function () {self.reload();});

};

lib_core.inherit(TrayAssetSearchTabContentModel, lib_core.Model);
lib_core.JsonParser.registerClass(TrayAssetSearchTabContentModel, "TrayAssetSearchTabContentModel");

module.exports = TrayAssetSearchTabContentModel;

TrayAssetSearchTabContentModel.prototype.reload = function() {

    // Implimented a delay - and - cancel system for reloading so that
    // the server does not get hit with too many calls (one call for every character is too many)
    var self = this;
    if(self.loadingQuery){
        clearTimeout(self.loadDelay);
    }

    self.loadingQuery = true;

    self.loadDelay = setTimeout(function(){
        self.loadingQuery = false;
        self.loadData(0);
    }, 1000);
};

TrayAssetSearchTabContentModel.prototype.getNext = function() {
    if(this.loading === true) return;   //getNext is called everytime a scrollevent is triggered and we are near the bottom of the list.
                                        //because loading the next results takes some time, we have to ignore these duplicate calls

    if(this.all_loaded === true) return;//do not attept to load more when all results already retrieved
    if(!this.data()) return;
    
    this.loadData(this.data().length);
};

TrayAssetSearchTabContentModel.prototype.loadData = function(start) {
    var self = this;

    var num_rows_per_call = 100;//TODO: reduce? temp hack

    this.loading = true;
    this.all_loaded = false;
    this.request_id += 1;
    var my_request_id = this.request_id;

    var queryFields = {};

    var default_queryFields = self.default_query_fields();
    for (var key in default_queryFields) {
        if (default_queryFields.hasOwnProperty(key)) {
            queryFields[key] = default_queryFields[key];
        }
    }

    queryFields["q"] = self.query();
    queryFields["start"] = start;
    queryFields["rows"]  = num_rows_per_call;

    if(self.sorting() && self.sorting().length > 0){
        if(self.sortIsProp()){
            queryFields["sort"]  = "properties." + self.sorting() + "%20" + self.sorting_direction();
        } else {
            queryFields["sort"]  = self.sorting() + "%20" + self.sorting_direction();
        }
    }

    var assetType = this.parent().type();
    var library = this.library();
    var floatTolerance = 10; // um

    var searchFilters = [];
    if(this.parent().searchFiltersEnabled()){
        this.parent().activeSearchFilters.forEach(function(ind, searchFilterData){
            // if float, search by +- 0.01mm
            if(!searchFilterData.currentProperty || searchFilterData.valShadow() === "" || searchFilterData.valShadow() === "NaN") return;
            
            if(searchFilterData.currentProperty.type == cio_config.types.positive_float){
                // if positive float, limit min to 0
                if(searchFilterData.getRealValue(searchFilterData.valShadow) - floatTolerance < 0){
                    searchFilters.push({
                        key: searchFilterData.key(),
                        min: 0,
                        max: searchFilterData.getRealValue(searchFilterData.valShadow) + floatTolerance
                    });
                } else {
                    searchFilters.push({
                        key: searchFilterData.key(),
                        min: searchFilterData.getRealValue(searchFilterData.valShadow) - floatTolerance,
                        max: searchFilterData.getRealValue(searchFilterData.valShadow) + floatTolerance
                    });
                }
            } else if(searchFilterData.currentProperty.type == cio_config.types.float){
                searchFilters.push({
                    key: searchFilterData.key(),
                    min: searchFilterData.getRealValue(searchFilterData.valShadow) - floatTolerance,
                    max: searchFilterData.getRealValue(searchFilterData.valShadow) + floatTolerance
                });
            } else {
                searchFilters.push({
                    key: searchFilterData.key(),
                    val: searchFilterData.getRealValue(searchFilterData.valShadow)
                });
            }
        })
    }
    
    this.dataLoader.dataManager.searchResources(assetType, library, queryFields, searchFilters, self.pathSuffix())
    .then(function(jsonData) {
        if(my_request_id !== self.request_id) return; //This is not the latest request in flight. Drop the response.
        var j = jsonData;
        self.numberOfResults(j["numberOfResults"]);
        if(start === 0) {
            self.data(j['results']);
        } else {
            self.data(self.data().concat(j['results']));
        }
        if(self.data().length >= j.numberOfResults)
            self.all_loaded = true;
        console.assert(self.data().length <= j['numberOfResults'], "More items in local data than on server");
        self.loading = false;

    }).catch(function(errorThrown) {
        // no need to throw error here, if we encountered something it has already been thrown
        self.loading = false;
    });

};
